import * as React from 'react';
import injectSheet from 'react-jss';
import { Modal, Table } from 'antd';
import { PaginationConfig } from 'antd/lib/table/interface';

const styles = theme => ({
  table: {
    '& ul': {
      position: 'absolute',
      right: '0px',
      zIndex: 1,
    }
  }
});

class FailureArrayHandleRfq extends React.PureComponent<any, any> {

  state:any = {
    columnNameForTable: [],
  };

  componentDidMount() {
    this.setState({
      columnNameForTable: this.generateColumnForTable(),
    });
  }

  generateColumnForTable = () => {
    const { classes, failureArray, id } = this.props;
    const columnData: any = [];
    // if (!failureArray || !failureArray.length) {
    //   return columnData;
    // }
    const indexList:any = [];
    indexList.unshift('reason');
    indexList.unshift(id);
    indexList.forEach((item, index) => {
      const itemToPush: any = {};
      itemToPush.title = item.replace('_', ' ').toUpperCase();
      itemToPush.dataIndex = item;
      itemToPush.key = item;
      itemToPush.width = ['ROW', 'SHIPMENT ID'].includes(itemToPush.title) ? 150 : '';
      columnData.push(itemToPush);
      if (item === 'reason') {
        itemToPush.render = (text, record) => {
          const reasons = record?.reasons || [];
          if (!reasons.length) {
            return '';
          }
          // One reason per line rather than a single comma-joined blob. Divs (not a <ul>) to avoid the
          // absolutely-positioned `& ul` rule in this component's stylesheet.
          return (
            <div>
              {reasons.map((data, reasonIndex) => (
                <div key={reasonIndex} style={{ marginBottom: reasonIndex < reasons.length - 1 ? 4 : 0 }}>
                  • {data.message}
                </div>
              ))}
            </div>
          );
        };
      } else if (id !== 'row') {
        itemToPush.render = (text, record) => {
          // tslint:disable-next-line:prefer-template
          return record.objectId;
        };
      }
    });

    return columnData;
  }

  handleModalClose = () => {
    this.props.onModalClose();
  }

  handleModalOk = () => {
    this.props.onModalClose();
  }

  render() {
    const { classes, failureArray, isVisible, isAmendment, enablePagination } = this.props;
    const paginationConfig = { 
        position: "top",
        pageSize: 100,
        size: "small",
      } as PaginationConfig;

    return (
      <Modal title="Errors" visible={isVisible} width={1200} okText="Ok"
        onCancel={this.handleModalClose}
        destroyOnClose
        onOk={this.handleModalOk}>
        <div>
          {isAmendment && <div style={{ fontStyle: 'italic', marginBottom: '10px' }}>
            All the line items will be sent for amendment together.</div>}
          <Table
            pagination={enablePagination ? paginationConfig : false}
            scroll={{ x: this.state.columnNameForTable.length * 150, y: '60vh' }}
            columns={this.state.columnNameForTable}
            dataSource={failureArray}
            rowKey={(record: any) => record.row}
            className={classes.table}
          >
          </Table>
        </div>

      </Modal>
    );
  }
}

const StyledComp = injectSheet(styles)(FailureArrayHandleRfq);
export default StyledComp;
